import {Card, Flex, Skeleton} from 'antd';

import {classNames} from '../../../../../../util/css';

import * as styles from './new-review-skeleton.scss';

export function NewReviewSkeleton(): JSX.Element {
    return (
        <Card>
            <Flex className={styles.ReviewSkeleton} gap={28} vertical>
                <Flex justify="space-between">
                    <Flex className={styles.ReviewSkeleton_userNameBlock} vertical>
                        <div className={styles.ReviewSkeleton__fullWidth}>
                            <Skeleton.Node active className={styles.ReviewSkeleton_node} />
                        </div>
                        <div className={styles.ReviewSkeleton__seventyWidth}>
                            <Skeleton.Node active className={styles.ReviewSkeleton_node} />
                        </div>
                    </Flex>
                    <Flex
                        className={classNames(
                            styles.ReviewSkeleton_userNameBlock,
                            styles.ReviewSkeleton_removeMobileBlock
                        )}
                    >
                        <Skeleton.Node active className={styles.ReviewSkeleton_node} fullSize />
                    </Flex>
                </Flex>
                <Flex
                    className={classNames(styles.ReviewSkeleton_fullWithMobileBlock, styles.ReviewSkeleton_bottomBlock)}
                    vertical
                >
                    <div className={styles.ReviewSkeleton__fullWidth}>
                        <Skeleton.Node active className={styles.ReviewSkeleton_node} />
                    </div>
                    <div
                        className={classNames(
                            styles.ReviewSkeleton__seventyWidth,
                            styles.ReviewSkeleton_fullWithMobileBlock
                        )}
                    >
                        <Skeleton.Node active className={styles.ReviewSkeleton_node} />
                    </div>
                    <div
                        className={classNames(
                            styles.ReviewSkeleton__fiftyWidth,
                            styles.ReviewSkeleton_fullWithMobileBlock
                        )}
                    >
                        <Skeleton.Node active className={styles.ReviewSkeleton_node} />
                    </div>
                </Flex>
            </Flex>
        </Card>
    );
}
